<template>
<div class="SpecialData">
    <div class="padding-20 bgc box-shadow" style="margin-bottom: 20px;font-size:16px;display: flex;justify-content: space-between;align-items: center;">
        <span>考试名称：{{param.examname}}</span>
        <el-button @click="cancel" type="text" size="small">返回考试列表</el-button>
    </div>
    <div class="padding-20 bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户管理" name="specialUserMgt">
                <specialUserMgt ref="specialUserMgt"></specialUserMgt>
            </el-tab-pane>
            <el-tab-pane label="打卡管理" name="specialPunchMgt">
                <specialPunchMgt ref="specialPunchMgt"></specialPunchMgt>
            </el-tab-pane>
            <el-tab-pane label="做题管理" name="specialExamMgt">
                <specialExamMgt ref="specialExamMgt"></specialExamMgt>
            </el-tab-pane>
            <el-tab-pane label="数据分析" name="specialAnalysisMgt">
                <specialAnalysisMgt ref="specialAnalysisMgt"></specialAnalysisMgt>
            </el-tab-pane>
            <el-tab-pane label="资料维护" name="specialMeansMgt">
                <specialMeansMgt ref="specialMeansMgt"></specialMeansMgt>
            </el-tab-pane>
            <el-tab-pane label="推荐配置" name="specialSettingMgt">
                <specialSettingMgt ref="specialSettingMgt"></specialSettingMgt>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import SpecialUserMgt from 'views/cms/special/components/specialUserMgt.vue'
import SpecialPunchMgt from 'views/cms/special/components/specialPunchMgt.vue'
import SpecialExamMgt from 'views/cms/special/components/specialExamMgt.vue'
import SpecialAnalysisMgt from 'views/cms/special/components/specialAnalysisMgt.vue'
import SpecialMeansMgt from 'views/cms/special/components/specialMeansMgt.vue'
import SpecialSettingMgt from 'views/cms/special/components/specialSettingMgt.vue'
export default {
    name: 'SpecialData',
    data() {
        return {
            param: {
                examcode: this.$route.query.examcode,
                examname: this.$route.query.examname
            },
            activeName: 'specialUserMgt'
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs[this.activeName].initData(this.param)
        })
    },
    methods: {
        cancel() {
            this.$router.back()
        },
        handleClick() {
            switch (this.activeName) {
                case 'specialUserMgt':
                    this.$refs.specialUserMgt.initData(this.param)
                    break
                case 'specialPunchMgt':
                    this.$refs.specialPunchMgt.initData(this.param)
                    break
                case 'specialExamMgt':
                    this.$refs.specialExamMgt.initData(this.param)
                    break
                case 'specialAnalysisMgt':
                    this.$refs.specialAnalysisMgt.initData(this.param)
                    break
                case 'specialMeansMgt':
                    this.$refs.specialMeansMgt.initData(this.param)
                    break
                case 'specialSettingMgt':
                    this.$refs.specialSettingMgt.initData(this.param)
                    break
            }
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SpecialUserMgt, SpecialPunchMgt, SpecialExamMgt, SpecialAnalysisMgt, SpecialMeansMgt, SpecialSettingMgt
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SpecialData {
    .filters {
        .el-input,.el-input input {
            width: 150px;
            height: 32px;
        }
        .el-select .el-input,.el-select .el-input input {
            width: 108px;
            height: 32px;
        }
        .el-range-editor.el-input__inner input{
            width: 80px;
        }
        .el-range-editor.el-input__inner{
            width: 220px;
        }
        .el-range-separator{
            line-height: 24px;
        }
    }

    .imageText{
        display: flex;
        .img{
            width: 60px;
            height: 60px;
            min-width: 60px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .tc{
        .cell{
            text-align: center;
        }
    }
    .filters{
        margin-bottom: 15px;
    }
}
</style>
